import React from "react";
import Button from "./Button";
import IngredientQuantity from "./ingredientQuantity";
import { formatDuration } from "../utils/timeUtils";
import { formatInstructionText } from "../utils/textFormatting";


const RecipeDetail = ({ recipe, imageUrl, extraActions }) => {
  const formatDate = (dateString) => {
    if (!dateString) return "";

    const date = dateString.toDate();

    if (isNaN(date.getTime())) return "";

    const options = { year: "numeric", month: "long", day: "numeric" };
    return date.toLocaleDateString(undefined, options);
  }
  return (
    <div className="flex-col space-y-12 print:space-y-6">
      <div className="flex flex-col md:flex-row gap-12">
        <section className="flex-1 space-y-4">
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold">
            {recipe.title}
          </h1>
          <div className="flex-col space-y-1">
            <p>
              <span className="font-bold">Serves: </span>{recipe.serves}
            </p>
            <p>
              <span className="font-bold">Cook Time: </span>{formatDuration(recipe.cookTime)}
            </p>
            <p className="print:hidden">
              <span className="font-bold">Source: </span>{recipe.source}
            </p>
            <p className="print:hidden">
              <span className="font-bold">Uploaded: </span> {formatDate(recipe.created)} by {recipe.userDisplayName}
            </p>
          </div>
          <p className="text-lg text-text-light print:hidden">
            {recipe.description}
          </p>
          <div className="flex gap-4 print:hidden">
            <Button type="secondary" onClick={() => { window.print() }}>Print</Button>
            {extraActions}
          </div>
        </section>
        {imageUrl && (
          <section className="flex-1 flex items-center md:flex-none md:w-1/4">
            <div className="h-auto">
              <img src={imageUrl} className="rounded-lg aspect-square object-scale-down" alt="logo" />
            </div>
          </section>
        )}
      </div>
      <div className="flex flex-col md:flex-row gap-12 print:gap-4 print:flex-row">
        <section className="flex-1 md:flex-none md:w-1/4 print:w-1/3 print:flex-none">
          <div>
            <h2 className="text-2xl lg:text-3xl font-bold mb-4">Ingredients</h2>
            <div className="flex flex-col gap-4">
              {recipe.ingredients.map((section, sectionIndex) => (
                <div key={sectionIndex}>
                  {section.section !== null && (
                    <h3 className="text-xl lg:text-2xl font-bold mb-2 flex items-center">{section.section}</h3>
                  )}
                  <ul className="list-disc list-inside space-y-3">
                    {section.items.map((ingredient, ingredientIndex) => (
                      <li key={ingredientIndex}>
                        {ingredient.quantity && (
                          <IngredientQuantity quantity={ingredient.quantity} />
                        )}
                        <span> {ingredient.units} {ingredient.name} {ingredient.optional && <span className="italic">- (optional)</span>} </span>
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>
        </section>
        <section className="flex-1">
          <div>
            <h2 className="text-2xl lg:text-3xl font-bold mb-4">Instructions</h2>
            <ol className="list-inside list-decimal marker:font-bold space-y-6">
              {recipe.instructions.map((instruction, index) => (
                <li
                  className="leading-relaxed"
                  key={index}
                  dangerouslySetInnerHTML={{ __html: formatInstructionText(instruction.text) }}
                />
              ))}
            </ol>
          </div>
        </section>
      </div>
    </div>
  )
}

RecipeDetail.defaultProps = {
  extraActions: null,
};

export default RecipeDetail;
